module.exports = __webpack_public_path__ + "media/demo2-en.b5be8bdc.mp4";